import React, { Component } from "react";
import { Drawer, message, Select } from "antd";
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { map, orderBy, filter, isEmpty } from "lodash";
import plus_icon from '../../../../../Assets/images/plus_icon.svg';
import cross_icon from '../../../../../Assets/images/cross_icon.svg';
import * as yup from "yup";
import Loader from "../../../../Common/Component/Loader";
import Script from "react-load-script";
import AllState from "../../../../../Assets/data/stateList.json";
import Axios from 'axios';
const {Option} = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let updateClick = false;

const notificationOrderList = [{key: 'technician_assigned', index: 0}, {key: 'technician_enroute', index: 1},
  {key: 'service_complete', index: 2}, {key: 'service_issues', index: 3}, {key: 'billing_notifications', index: 4}]

class UpdateContact extends Component {

  state = {
    phone_numbers: [],
    emails: [],
    org_phone_numbers: [],
    org_emails: [],
    phone: '',
    email: '',
    sms: '',
    uuid: '',
    is_btn_active: false,
    loader: false,
    notificationList: [],
    first_name: '',
    last_name: '',
    address: {},
    is_print_and_mail_invoices: true,
    is_email_invoice: false,
    errors: {},
    is_address_manually: false,
    is_dummy_email:false,
  }

  componentDidMount() {
    const {customerId, getCustomerDetail, getNotification} = this.props;
    if (customerId) {
      getCustomerDetail(customerId) // get customer detail
      getNotification({user__uuid: customerId}) // get notification list
    }

    if (this.props.customerList && this.props.customerList.customer && Object.keys(this.props.customerList.customer).length > 0) {
      this.setState({
        is_print_and_mail_invoices: this.props?.customerList?.customer?.invoice_address ? this.props?.customerList?.customer?.is_print_and_mail_invoices : this.state.is_print_and_mail_invoices,
        is_email_invoice: this.props?.customerList?.customer?.invoice_address ? this.props?.customerList?.customer?.is_email_invoice : this.state.is_email_invoice
      });
    }

    setTimeout(() => {
      // set invoice address if is_print_and_mail_invoices is true
      if (this.props?.customerList?.customer?.is_print_and_mail_invoices) {
        if (this.refs["address"]) {
          let addressStr = this.props?.customerList?.customer?.invoice_address?.address ? `${this.props?.customerList?.customer?.invoice_address?.address}` : '';
          addressStr += this.props?.customerList?.customer?.invoice_address?.city ? `, ${this.props?.customerList?.customer?.invoice_address?.city}` : '';
          addressStr += this.props?.customerList?.customer?.invoice_address?.state ? `, ${this.props?.customerList?.customer?.invoice_address?.state}` : '';
          addressStr += this.props?.customerList?.customer?.invoice_address?.zip_code ? `, ${this.props?.customerList?.customer?.invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
        const address = {
          address: this.props?.customerList?.customer?.invoice_address?.address ? `${this.props?.customerList?.customer?.invoice_address?.address}` : '',
          city: this.props?.customerList?.customer?.invoice_address?.city ? `${this.props?.customerList?.customer?.invoice_address?.city}` : '',
          state: this.props?.customerList?.customer?.invoice_address?.state ? `${this.props?.customerList?.customer?.invoice_address?.state}` : '',
          zip_code: this.props?.customerList?.customer?.invoice_address?.zip_code ? `${this.props?.customerList?.customer?.invoice_address?.zip_code}` : '',
        }
        this.setState({
          address: address
        });
      }
    }, 100);
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    this.setState({loader: false});

    // get customer info
    if (nextProps.customerList && nextProps.customerList.customer && Object.keys(nextProps.customerList.customer).length > 0) {
      const phone_numbers = nextProps?.customerList?.customer?.phone_numbers?.length > 0 ? orderBy([...nextProps?.customerList?.customer?.phone_numbers], 'primary', 'desc') : [{phone: "", type: "home_phone", can_send_sms: false, primary: true}];
      const emails = nextProps?.customerList?.customer?.emailaddress_set?.length > 0 ? orderBy([...nextProps?.customerList?.customer?.emailaddress_set], 'primary', 'desc') : [{email: nextProps?.customerList?.customer?.email, primary: true}];
      this.setState({phone_numbers, emails, org_phone_numbers: phone_numbers, org_emails: emails,
        uuid: nextProps?.customerList?.customer?.uuid,
        first_name: nextProps?.customerList?.customer?.first_name,
        last_name: nextProps?.customerList?.customer?.last_name,
        // is_dummy_email:nextProps?.customerList?.customer?.is_dummy_email
      });
      let NewEmails = emails && emails.length && emails.filter(email => {
        return email.email.includes('doody.com');
      }); 
      
      if(NewEmails && NewEmails.length){
        this.setState({is_dummy_email:true})
      }


      if (updateClick) {
        // message.success('Updated successfully');
      }
    }

    // get notification list
    if (Object.keys(nextProps?.notificationList?.data).length > 0
      && JSON.stringify(nextProps?.notificationList?.data?.results) !== JSON.stringify(this.state.notificationList)) {
      let list = [], result = nextProps?.notificationList?.data?.results
      map(notificationOrderList, (obj) => {
        const data = result.filter(x => x.type === obj.key)
        list[obj.index] = data[0]
      })
      this.setState({ notificationList: list, loader: false });
    }

    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }
  }

  // genarate gibberrish email address
  genarateGibberrishEmail = () => {
    let newEmail = [{email: '', primary: true}]
    newEmail[0].email = this.create_UUID() + '@doody.com'
    this.setState({emails:newEmail,is_dummy_email:true});  
  }

  create_UUID = () => {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (dt + (Math.random()*16))%16 | 0;
      dt = Math.floor(dt/16);
      return (c==='x' ? r :(r&(0x3|0x8))).toString(16);
    });
    return uuid;
  }

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: obj}, () => {
          if (!obj?.address || !obj?.state || !obj.city) {
            message.error('Please enter valid address');
          }
        })
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  //on change
  onChange = (row) => {
    const {emails} = this.state;
    emails.splice(row, 1);
    this.setState({emails});
  };

  // on primary email changed
  onEmailPrimaryChanged = (item) => {
    const {emails} = this.state;
    const index = emails.findIndex(obj => obj.email === item.email)
    emails.splice(index, 1);
    this.setState({emails})
  }

  // on text change
  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  // on print invoice change
  onPrintInvoiceChange = (e) => {
    const { invoice_address } = this.props?.customerList?.customer;
    const address = {
      address: invoice_address?.address ? `${invoice_address?.address}` : '',
      city: invoice_address?.city ? `${invoice_address?.city}` : '',
      state: invoice_address?.state ? `${invoice_address?.state}` : '',
      zip_code: invoice_address?.zip_code ? `${invoice_address?.zip_code}` : '',
    }
    if (e.target.checked) {
      setTimeout( () => {
        if (this.refs["address"]) {
          let addressStr = invoice_address?.address ? `${invoice_address?.address}` : '';
          addressStr += invoice_address?.city ? `, ${invoice_address?.city}` : '';
          addressStr += invoice_address?.state ? `, ${invoice_address?.state}` : '';
          addressStr += invoice_address?.zip_code ? `, ${invoice_address?.zip_code}` : '';
          this.refs["address"].value = addressStr;
        }
      });
      this.setState({
        is_print_and_mail_invoices: e.target.checked,
        address: address
      });
    } else {
      this.refs["address"].value = null;
      this.setState({
        is_print_and_mail_invoices: e.target.checked,
        address: address
      });
    }
  }

  // on email invoice change
  onEmailInvoiceChange = (e) => {
    if (e.target.checked) {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    } else {
      this.setState({
        is_email_invoice: e.target.checked,
      })
    }
  }

  //on add
  onAdd = (name, type) => {
    const {phone_numbers, emails, phone, sms, email} = this.state;
    if (name === 'phone') {
      phone_numbers.push({phone: type === 'phone' ? phone : sms, can_send_sms: false, primary: false });
      this.setState({phone_numbers}, () => this.onClear());
    } else {

      let NewEmails = emails && emails.length && emails.filter(email => {
        return !email.email.includes('doody.com');
      });
      NewEmails.push({email, primary: NewEmails?.length === 0});
      emails.push({NewEmails, primary: false});
      this.setState({emails:NewEmails,is_dummy_email:false}, () => {this.onClear()});
    }
  };

  // on clear
  onClear = () => {
    this.setState({phone: '', email: '', sms: '', address: {}});
  };

  // on clear
  onClearAll = () => {
    this.setState({phone: '', email: '', sms: '', notificationList: [],  first_name: '', last_name: '', address: {} });
  };

  onNotificationChanged = (e, permissionType) => {
    const {notificationList} = this.state;

    const idx = notificationList?.findIndex(obj => obj.type === permissionType);
    if (idx > -1) {
      notificationList[idx] = Object.assign(notificationList[idx], { [e.target.name]: e.target.checked });
      this.setState({ notificationList });
    }
  }

  // on update
  onUpdateClick = () => {
    const { onUpdate, closeDrawer, updateNotificationById } = this.props;
    const { phone_numbers, emails, uuid, notificationList, first_name, last_name, address, is_print_and_mail_invoices, is_email_invoice, is_dummy_email } = this.state;
    this.setState({loader: true})
    let isPrimaryExist = false;

    filter(phone_numbers, (obj) => {
      if (obj.primary) {
        isPrimaryExist = true
      }
    })

    if (!isPrimaryExist) {
      phone_numbers[0].primary = true
    }

    const list = notificationList?.map(x => ({uuid: x.uuid, email: x?.email, text: x?.text}))
    setTimeout(() => {
      onUpdate(uuid, {phone_numbers, emailaddress_set: emails, is_dummy_email, first_name, last_name, invoice_address: (address?.street_number && address?.route) ? {...address, address: `${address?.street_number} ${address?.route}`} : address, is_print_and_mail_invoices: is_print_and_mail_invoices, is_email_invoice: is_email_invoice })
      updateNotificationById(list)
      closeDrawer();
      this.onClearAll();
    }, 1000)
  };

  //on cancel
  onCancel = () => {
    const {closeDrawer} = this.props;
    const {org_phone_numbers, org_emails} = this.state;
    this.setState({phone_numbers: org_phone_numbers, emails: org_emails}, () => {
      closeDrawer();
      this.onClearAll();
    })
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on phone number change
  onPhoneChange = (e, index) => {
    const {phone_numbers} = this.state;
    Object.assign(phone_numbers[index], {[e.target.name]: e.target.value})
    if (e.target.name === 'type' && e.target.value === 'home_phone') {
      Object.assign(phone_numbers[index], {'can_send_sms': false})
    }
    this.setState({phone_numbers})
  }

  //Add multiple phone number
  addMorePhone = (e) => {
    e.preventDefault();
    let { phone_numbers } = this.state;
    let temp_phone = {phone: "", type: "home_phone", can_send_sms: false}
    phone_numbers.push(temp_phone);
    this.setState({ phone_numbers })
  }
  
  //remove phone number
  removePhone = (e, index) => {
    e.preventDefault();
    let { phone_numbers } = this.state;
    phone_numbers.splice(index, 1);
    this.setState({ phone_numbers })
  }

  // validate required fields
  validate = () => {
    const { phone_numbers, emails, first_name, last_name, address, is_print_and_mail_invoices, is_email_invoice } = this.state;
    const schema = yup.object().shape({
      first_name: yup.string().required('First name is required.'),
      last_name: yup.string().required('Last name is required.'),
      address: yup.object().shape({
        address: is_print_and_mail_invoices ? yup.string().required('address is required.') : '',
        city: is_print_and_mail_invoices ? yup.string().required('city is required.') : '',
        state: is_print_and_mail_invoices ? yup.string().required('state is required.') : '',
        zip_code: is_print_and_mail_invoices ? yup.string().required('zip code is required.') : ''
      }),
      phone_numbers: yup.array(yup.object({
        phone: yup.string().required('Phone is required'),
        type: yup.string().required('Type is required'),
      })).required("Phone number is required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address is required"),
    });
    const data = { phone_numbers, emails, first_name, last_name, address, is_print_and_mail_invoices, is_email_invoice }
    setTimeout(() => {
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({is_btn_active: true, errors: {}});
        this.onUpdateClick()
      }).catch((err) => {
        let err_data = {};
        map(err.inner, (item) => {err_data[item.path] = item.message});
        this.setState({is_btn_active: false, errors: err_data});
      //  message.error('Please enter valid invoice address');
      })
    }, 500);
  }

  // render phone numbers
  renderPhone = (item, index) => {
    return (
      <div key={`phone_update${index}`} className="form-group">
        <div className={"half-fitem fitem"}>
          <div className="half-fitem fitem">
            <input
              type="text"
              name={"phone"}
              value={item?.phone}
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onPhoneChange(e, index)}
              className="form--control"
              placeholder="Phone Number"
              max={10}
              maxLength={10}
            />
          </div>
          <div className={"half-fitem fitem flex ai-center"}>
            <Select
              defaultValue={"home_phone"}
              showArrow
              name={'type'}
              virtual={false}
              style={{ width: '100%' }}
              value={item?.type}
              onChange={(e) => this.onPhoneChange({target: {name: 'type', value: e}}, index)}
            >
              <Option value="home_phone">Home</Option>
              <Option value="mobile">Mobile</Option>
            </Select>
            {index === 0 ? <a href="/#" onClick={(e) => { this.addMorePhone(e); }}><img className="icoimg" src={plus_icon} alt="" /></a> :
              <a href="/#" onClick={(e) => { this.removePhone(e, index); }}><img className="icoimg" src={cross_icon} alt="" /></a>}
          </div>         
        </div>
        {item?.type === 'mobile' ? <div className="fitem-check">
          <input
            type="checkbox" name="can_send_sms"
            className="fitem-ck-input"
            checked={item?.can_send_sms}
            id={`sendSMS${index}`}
            onChange={(e) => this.onPhoneChange({target: {name: 'can_send_sms', value: e.target.checked}}, index)}
          />
          <label htmlFor={`sendSMS${index}`} className="fitem-ck-txt">
            Accept text messages at this number
          </label>
        </div> : ''}
      </div>
    )
  }

  renderNotification = (item, index) => {
    return (
      <div className={"flex ai-center mb-10"} key={`notification${index}`}>
        <label><b>{item?.type_display}</b></label>
        <div className="inline-check-list rcheck flex sm-checks gcheck">
          <div className="fitem-check">
            <input
              type="checkbox"
              className="fitem-ck-input"
              id={`custEmail${index}`}
              name={`email`}
              checked={item?.email}
              onChange={(e) => this.onNotificationChanged(e, item?.type)}
            />
            <label htmlFor={`custEmail${index}`} className="fitem-ck-txt"/>
          </div>
          <div className="fitem-check" style={{marginLeft: "22px", marginRight: "5px"}}>
            <input
              type="checkbox"
              className="fitem-ck-input"
              id={`custText${index}`}
              name={`text`}
              checked={item?.text}
              onChange={(e) => this.onNotificationChanged(e, item?.type)}
            />
            <label htmlFor={`custText${index}`} className="fitem-ck-txt"/>
          </div>
        </div>
      </div>

    )
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  // Google Map Place API
  handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', 'geometry']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  // on start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      // location = { lat: addressObject.geometry.location.lat(), lng: addressObject.geometry.location.lng() }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({address: obj}, () => {
        if (!obj?.address || !obj?.state || !obj.city) {
          message.error('Please enter valid address');
        }
      })
    }).catch((err) => {
      console.log(err)
    })
    // this.setState({address: obj}, () => {
    // const address_obj = (obj?.street_number || obj?.route) ? {...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}`} : obj
    // const address = `${address_obj.address} ${address_obj.city} ${address_obj.state} ${address_obj.zip_code}`
    // this.props.resetGeocodeAddress()
    // this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
  }

  render() {
    const {openDrawer} = this.props;
    const {is_dummy_email, emails, phone_numbers, email, loader, notificationList, first_name, last_name, errors, address, is_address_manually, is_print_and_mail_invoices, is_email_invoice } = this.state;
    let errorKeys = errors ? Object.keys(errors) :[];
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.onCancel()}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer filter_drawer_wrapper">
          {loader && <Loader />}
          <div className="card-row">
            <div className="card-full">
              <div className="flex ai-center">
                <h4 className="mb-0">Update Contact Details</h4>
                <CloseOutlined onClick={() => this.onCancel()}/>
              </div>

              {/* <h5 className="mt-30">{`Customer's Name`}</h5> */}
              <div className={"flex"}>
                <div className={"half-fitem fitem"}>
                  <h5 className="mt-30">{`First Name`}</h5>
                  <input
                    name="first_name"
                    type="text"
                    placeholder={"First Name"}
                    value={first_name}
                    onChange={(e) => this.onTextChange(e)} />
                  {errors?.['first_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['first_name']}</label> : ''}
                </div>
                <div className={"half-fitem fitem"} style={{marginLeft: "10px"}}>
                  <h5 className="mt-30">{`Last Name`}</h5>
                  <input
                    name="last_name"
                    type="text"
                    placeholder={"Last Name"}
                    value={last_name}
                    onChange={(e) => this.onTextChange(e)} />
                  {errors?.['last_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['last_name']}</label> : ''}
                </div>
              </div>

              <h5 className=" mt-30">Phone Number</h5>
              {map(phone_numbers, this.renderPhone)}
              {
                errorKeys.length && errorKeys.filter(s => s.includes('phone_numbers')).length ? <label className="new_err_msg"><i className="las la-info-circle"/>{"Phone number is required"}</label> : ''
              }

              {/* Emails */}
              <h5 className=" mt-30">Email Addresses</h5>
              {
                map(emails, (item, index) => (item?.email && !is_dummy_email) ?
                  <div className="fitem-check" key={`checkboxEmail${index}`}>
                    {item?.primary ? <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`checkboxEmail${index}`}
                      name={`email${index}`}
                      checked={item?.primary}
                      readOnly
                    /> : ''}
                    <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black text-lowercase">
                      {`${item?.email?.toLowerCase()} ${item?.primary ? '(Primary)' : ''}`}
                    </label>
                    {!item?.primary ? <a className="red float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.onEmailPrimaryChanged(item)}}>Remove</a> : ''}
                  </div> : ''
                )
              }
              <div className="fitem fitem-rinner mt-10">
                <input
                  name="email"
                  type="text"
                  placeholder={"Add New Email Address"}
                  value={email}
                  onChange={(e) => this.onTextChange(e)} 
                />
                <button
                  className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
                  disabled={!REGULAR_EXPRESSION_EMAIL.test(email)}
                  onClick={() => this.onAdd('email')}><PlusOutlined /></button>
              </div>
              { is_print_and_mail_invoices &&
                <div className="fitem">
                  <h5 htmlFor="address" className=" mt-10">Invoice Address</h5>
                  <div className="google_search_place">
                    <Script
                      url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                      onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                    />
                    <input
                      autoComplete="off"
                      type="text"
                      ref="address"
                      placeholder={"Search for Invoice Address"}
                      name="google_address"
                      id="google_address"
                      onChange={(e) => {
                        if (!e.target.value) {
                          this.setState({
                            address: { address: '', state: '', city: '', zip_code: '' }
                          })
                        }
                      }}
                      disabled={is_address_manually}
                    />
                    <b>or <a href="/" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: true,
                        address: { address: '', state: '', city: '', zip_code: '' },
                      }, () => {
                        if (this.refs['address']) {
                          this.refs['address'].value = '';
                        } })
                    }}><u>enter address manually</u></a></b>
                  </div>
                  {
                    is_address_manually &&
                    <div className="manually_address">
                      <a href="/#" onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          is_address_manually: false,
                          address: { address: '', state: '', city: '', zip_code: '' },
                        })
                      }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                      <br />

                      <div className="form-group mb-20">
                        <div className="fitem">
                          <input
                            type="text"
                            placeholder="Address"
                            name="address"
                            value={address?.address}
                            onChange={(e) => this.onAddressChange(e)}
                          />
                        </div>
                        <div className="half-fitem fitem">
                          <div className="half-fitem fitem">
                            <input
                              type="text"
                              placeholder="City"
                              name="city"
                              value={address?.city}
                              onChange={(e) => this.onAddressChange(e)}
                            />
                          </div>
                          <div className="half-fitem fitem">
                            <Select
                              showArrow={true}
                              name="state"
                              placeholder="State"
                              onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                              value={address?.state || undefined}
                              virtual={false}
                            >
                              {this.renderAllState()}
                            </Select>
                          </div>
                          <div className="half-fitem fitem">
                            <input
                              type="text"
                              className='form--control'
                              placeholder="ZIP Code"
                              name="zip_code"
                              maxLength={5}
                              minLength={5}
                              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                              value={address?.zip_code || ''}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code']) ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid invoice address'}</label> : ''}
                </div>
              }
              <div className="fitem-check mt-10">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`printInvoice`}
                  name={`is_print_and_mail_invoices`}
                  checked={is_print_and_mail_invoices}
                  onChange={(e) => this.onPrintInvoiceChange(e)}
                />
                <label htmlFor={`printInvoice`} className="fitem-ck-txt">Print and Mail Invoice</label>
              </div>
              <div className="fitem-check mt-10">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`emailInvoice`}
                  name={`is_email_invoice`}
                  checked={is_email_invoice}
                  onChange={(e) => this.onEmailInvoiceChange(e)}
                />
                <label htmlFor={`emailInvoice`} className="fitem-ck-txt">Email invoices</label>
              </div>

              <div className="card-body mt-20">
                <label>Notifications</label>
                <div className="fitem-check text-right">
                  <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
                  <label htmlFor="checkbox" className="fitem-ck-txt text-right" style={{marginLeft: "22px"}}><b>Text</b></label>
                </div>

                {map(notificationList, this.renderNotification)}
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            <button
              // type="submit"
              // disabled={!is_btn_active}
              className={`btn btn-warning`}
              onClick={() => this.validate()}>
              Update
            </button>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default UpdateContact;